import { useState, useLayoutEffect, ReactNode } from 'react';

const Marquee = ({
  speed = 30,
  children,
}: {
  speed?: number;
  children: ReactNode;
}) => {
  let [element, setElement] = useState<HTMLDivElement | null>(null);
  let [contentWidth, setContentWidth] = useState(0);

  useLayoutEffect(() => {
    if (!element) return;

    let observer = new ResizeObserver(() => {
      setContentWidth(element.scrollWidth);
    });
    observer.observe(element);

    return () => observer.disconnect();
  }, [element]);

  let duration = contentWidth > 0 ? contentWidth / speed : 0;
  let animationStyle = duration
    ? { animation: `marquee-scroll ${duration}s linear infinite` }
    : undefined;

  return (
    <div style={{ overflow: 'hidden', display: 'flex' }}>
      <style>{`@keyframes marquee-scroll { from { transform: translateX(0%) } to { transform: translateX(-100%) } }`}</style>
      <div
        ref={setElement}
        style={{
          flex: '0 0 auto',
          minWidth: '100%',
          display: 'flex',
          ...animationStyle,
        }}
      >
        {children}
      </div>
      <div
        aria-hidden
        style={{
          flex: '0 0 auto',
          minWidth: '100%',
          display: 'flex',
          ...animationStyle,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Marquee;
